// assets/js/utilities/utilitiesAll.js
import { initSwiper } from './swiper';
import { initHamburgerMenu } from './hamburgerMenu';
import { initToTop } from './toTop';
import { initZoomModal } from './zoomModal';
import { initPopupToggle } from './popupToggle';
import { initMovieModal } from './movieModal';
import { initDisclaimer } from './disclaimer';
import { initHeaderVisibility } from './headerVisibility';
import { initTabs } from './tabs';
import { initMovieChapter } from './movieChapter';
import { initAccordion } from './accordion';
// import { initStickyContact } from './stickyContact';
// import { initModal } from './modalToggle';
// import { initLocalBlockToggle } from './localBlockToggle';
// import { initSupportPulldown } from './pulldownSupport';
// import { initKvImageSwitcher } from './kvImageSwitcher';

export default async function utilitiesAll() {
  try {
    await Promise.all([
      initSwiper(),
      initHamburgerMenu(),
      initHeaderVisibility(),
      initTabs(),
      initDisclaimer(),
      initAccordion(),
      // initMovieChapter(),
      // initToTop(),
      // initZoomModal(),
      // initPopupToggle(),
    ]);
  } catch (error) {
    console.error("Error in utilitiesAll:", error);
  }
}
